var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',[_vm._v(" "+_vm._s(_vm.object.createdAt.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit", }) + " - " + _vm.object.createdAt.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit", })))])
}
var staticRenderFns = []

export { render, staticRenderFns }